import { PageShell } from '@/components/ui';
import { CourierManagementSection } from '../components/CourierManagementSection';

/** QA-510 [기본설정 > 배송 업체 관리] — 고도몰 [배송 정책 > 배송 업체 관리]. */
export const CourierManagementPage = () => (
  <PageShell title="배송 업체 관리" description="송장 입력 택배사 목록과 배송조회 링크입니다. 송장 일괄등록의 택배사 안내 목록에도 바로 반영됩니다.">
    <CourierManagementSection />
  </PageShell>
);
